import { Typography } from '@sunday/component';
import cn from 'classnames';
import style from './MarketingTypography.module.scss';

const Body = ({ className, ...props } : any) => (
  <Typography.Body className={cn(style['marketing-typography'], className)} {...props}>
    {props.children}
  </Typography.Body>
);

const Title = ({ className, ...props } : any) => (
  <Typography.Title className={cn(style['marketing-typography'], className)} {...props}>
    {props.children}
  </Typography.Title>
);

const Display = ({ className, ...props }: any) => (
  <Typography.Display className={cn(style['marketing-typography'], className)} {...props}>
    {props.children}
  </Typography.Display>
);

const Headline = ({ className, ...props }: any) => (
  <Typography.Headline className={cn(style['marketing-typography'], className)} {...props}>
    {props.children}
  </Typography.Headline>
);


export default { Title, Display, Body, Headline };
